import { gql } from '@apollo/client';

export const MARK_STAFF_AS_PRIMARY = gql`
  mutation markUserAsPrimary($data: PatientUserIdsInput!) {
    markUserAsPrimary(data: $data) {
      id
    }
  }
`;
